// // import _ from 'lodash'
import { searchByText, searchDesign, orderByFields } from "./dbUtility.js"
import { filterByOrg, filterByUser } from './rolesManagement'

export const ListManagement = {

    data() {
        return {
            objects: [],
            o_loading: false,
            o_selector: {},
            selector: {},
            custom_selector: {},
            fields: [],
            db: '',
            sort_asc: true,
            sort_sel_fields: { values: ['updated', 'created'] },
            filter: {},
            advanced_search: false,
            filtered_org: null,
            filtered_users: null,
            switchView: '',
            list_type: null,
            page: 1,
            sort_fields: {},
            sorting_fields: [{}]
        }
    },
    beforeDestroy() {
        this.objects = null
    },
    methods: {
        async search() {
            if (this.filtered_org) {
                this.filter.org = this.filtered_org
            }
            this.page = 1;
            this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: this.filter, page: 1,  sort_fields: this.sort_fields})
            await this.updateSearch()
        },
        async cancelSearch() {
            let resetAll = this.isAdvancedSearch()
            this.closeAdvancedSearch()
            if (resetAll){
                console.log('RESET AND RESET', resetAll)
                this.resetSearch()
                if (this.filtered_org) {
                    this.filter.org = this.filtered_org
                }
                this.page = 1;
                await this.updateSearch()
            }
        },
        // async cancelSearch() {
        //     this.resetSearch()
        //     if (this.filtered_org) {
        //         this.filter.org = this.filtered_org
        //     }
        //     this.page = 1;
        //     this.closeAdvancedSearch()
        //     await this.updateSearch()
        // },
        changeSelector() {
            this.initSelector()
            this.selector = _.cloneDeep(this.o_selector)
            this.customSelection()
            console.log("SEARCH SELECTOR", this.selector)
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        openAdvancedSearch() {
            this.advanced_search = true
        },
        initSelector() {

        },
        customSelection() {

        },
        async findObjects() {
            let res = await this.$store.state.$pouch.find(this.db, {
                selector: this.selector,
                fields: this.fields.concat(this.sort_sel_fields)
            })
            this.objects = this.orderBy(res.docs, this.sort_fields)
        },
        async searchFromDesign(o_type, search) {
            let res = await searchByText(this.$store.state.$pouch, this.db, o_type, search)
            if (res != null) {
                //console.log('OBJECTS', res)
                let sorted = this.orderBy(res, this.sort_fields)
                this.objects = sorted.map(item => { return { _id: item.id } })

            }
        },
        // (db_ref, db, view, sel_type, selectors, reduce)
        async searchFromDesignNew(view, sel_type, selectors, reduce) {
            //console.log('searchFromDesignNew PARAMS', view, sel_type, selectors, reduce)
            let res = await searchDesign(this.$store.state.$pouch, this.db, view, sel_type, selectors, reduce)
            if (res != null) {
                return res.map(item => { return { _id: item.id, value: item.value } })
            }
        },
        orderBy(items, fields) {
            return orderByFields(items, fields)
        },
        changeOrder() {
            //console.log('changeORDER', this.sort_fields)
            this.page = 1
            this.objects = this.orderBy(this.objects, this.sort_fields)
                //console.log(this.objects)
        },
        updateSearch() {

        },
        resetSearch() {

        },
        setSwitchView() {
            if (this.$store.state.user.roles.includes('reviewer')){
                this.switchView = null
            } else if (this.viewFilterChoices || filterByOrg('operation', 'view_org', this.$store.state.user.roles)) {
                this.switchView = 'org'
            } else if (filterByUser('operation', 'view_owner', this.$store.state.user.roles)) {
                this.switchView = 'owner'
            }
        },
        changeSwitchFilter() {
            switch (this.switchView) {
                case 'owner':
                    this.filtered_user = this.$store.state.user._id
                    this.filtered_org = null
                    break;
                case 'org':
                    this.filtered_org = this.$store.state.user.org_id
                    this.filtered_user = null
                    break
                default:
                    this.filtered_org = null
                    this.filtered_user = null
            }
            this.updateSearch()
        },
        viewOrgSelection() {
            if (this.list_type) {
                return filterByOrg(this.list_type, 'view', this.$store.state.user.roles)
            }
            return true
        },
        viewUserSelection() {
            if (this.list_type) {
                return filterByOrg(this.list_type, 'view', this.$store.state.user.roles) || filterByOrg(this.list_type, 'view_org', this.$store.state.user.roles)
            }
            return true
        },
        filterUsersSelection() {
            let that = this
            let filtered = Object.values(this.$store.state.users)
            if (this.list_type) {
                if (filterByOrg(this.list_type, 'view_org', this.$store.state.user.roles)) {
                    filtered = (Object.values(that.$store.state.users)).filter((user) => {
                        return user.org_id == that.$store.state.user.org_id
                    })
                } else if (filterByOrg(this.list_type, 'view_owner', this.$store.state.user.roles)) {
                    filtered = [that.$store.state.user]
                }
            }
            filtered = (Object.values(that.$store.state.users)).filter((user) => { // not dismissed
                    return !user.dismissed
            })
            let sorted_users = _.sortBy(filtered, [function(o) { return o.name.toUpperCase(); }])
            that.filtered_users = sorted_users;
        },
        restore_history_params() {
            let filter = null;
            let page = 1;
            let sort_fields = this.sorting_fields[0]
            let history_params = this.$store.state.search[this.$router.history.current.fullPath];
            if (history_params) {
                filter = history_params.filter ? history_params.filter : null;
                page = history_params.page ? history_params.page : 1;
                sort_fields = _.isEmpty(history_params.sort_fields) ? this.sorting_fields[0] : history_params.sort_fields ;
            }
            this.page = page;
            this.sort_fields = sort_fields
            return filter;
        },
        isAdvancedSearch(){
            let history_params = this.$store.state.search[this.$router.history.current.fullPath];
            if (history_params &&  history_params.filter) {
                return true;
            }
            return false
        }
    },
    computed: {
        viewFilterChoices() {
            return filterByUser('operation', 'view_owner', this.$store.state.user.roles) && filterByOrg('operation', 'view_org', this.$store.state.user.roles)
        }
    },
    watch: {
        page() {
            let history_params = this.$store.state.search[this.$router.history.current.fullPath];
            let filter = null;
            let sort_fields = this.sorting_fields[0]
            if (history_params) {
                filter = history_params.filter ? history_params.filter : null;
                sort_fields = _.isEmpty(history_params.sort_fields) ? this.sorting_fields[0] : history_params.sort_fields ;
            }
            this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: filter, page: this.page, sort_fields: sort_fields })
        },
        sort_fields() {
            console.log("WATCH SORT FIELDS")
            let history_params = this.$store.state.search[this.$router.history.current.fullPath];
            let filter = null;
            let page = 1;
            if (history_params) {
                filter = history_params.filter ? history_params.filter : null;
                page = history_params.page ? history_params.page : 1;
            }
            this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: filter, page: page, sort_fields: this.sort_fields })
        }
    }

}